import { BreadcrumbItem, NavigationTreeService } from '../../_services/navigation-tree.service';
import { Component, OnInit } from '@angular/core';

import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { Observable } from 'rxjs';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'app-breadcrumb',
    standalone: true,
    imports: [CommonModule, MatIconModule, RouterModule, TranslocoModule],
    templateUrl: './breadcrumb.component.html',
    styleUrl: './breadcrumb.component.scss'
})
export class BreadcrumbComponent implements OnInit {
    breadcrumbs$: Observable<BreadcrumbItem[]>;
    showBreadcrumb$: Observable<boolean>;

    constructor(private navigationTreeService: NavigationTreeService) {
        this.breadcrumbs$ = this.navigationTreeService.breadcrumbs$;
        this.showBreadcrumb$ = this.navigationTreeService.showBreadcrumb$;
    }

    ngOnInit(): void {}

    isLastItem(item: BreadcrumbItem): boolean {
        const lastIndex = this.navigationTreeService
            .getCurrentPath()
            .split('/')
            .filter(Boolean)
            .length - 1;
        return item.level === lastIndex;
    }
}